const PoliticaDevoluciones = () => {
  return (
    <div className="container my-5">
      <div className="text-center mb-5">
        <h1 className="fw-bold">Política de Cambios, Devoluciones y Reembolsos</h1>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-body p-4 p-md-5">

          <h5 className="fw-bold">1. Introducción</h5>
          <p>
            La presente Política de Cambios y Devoluciones establece las
            condiciones aplicables a los productos adquiridos a través de la
            tienda online <strong>MarketLuz</strong>.
          </p>
          <p>
            MarketLuz actúa como una plataforma de intermediación entre
            vendedores y compradores. Las condiciones específicas de cambios y
            devoluciones dependen del vendedor del producto, respetando la
            normativa peruana de protección al consumidor.
          </p>
          <p>
            Esta política aplica a los productos y servicios adquiridos a
            través de nuestra web y/o aplicación.
          </p>

          <h5 className="fw-bold mt-4">2. Condiciones para cambios y devoluciones</h5>
          <ul>
            <li>
              El plazo para solicitar un cambio o devolución es de
              <strong> 7 días calendario</strong> contados desde la recepción
              del producto.
            </li>
            <li>
              El producto debe estar sin uso, en su empaque original, con
              etiquetas completas y sin daños.
            </li>
            <li>No son elegibles para cambios o devoluciones:</li>
            <ul>
              <li>Productos usados</li>
              <li>Productos personalizados</li>
              <li>
                Productos perecibles o alimentos, salvo defecto comprobado
              </li>
              <li>
                Otros productos excluidos según lo indicado por el vendedor
              </li>
            </ul>
          </ul>

          <h5 className="fw-bold mt-4">
            3. Proceso para solicitar un cambio o devolución
          </h5>
          <ol>
            <li>
              Contactar al servicio de atención al cliente a través de:
              <ul>
                <li>Correo electrónico: <strong>[admin@marketluz.com]</strong></li>
                <li>Teléfono o WhatsApp: <strong>[+1 505 3899 069]</strong></li>
              </ul>
            </li>
            <li>Completar el formulario de solicitud de cambio o devolución.</li>
            <li>
              Enviar la documentación requerida:
              <ul>
                <li>Número de pedido</li>
                <li>Comprobante de compra</li>
                <li>Fotos del producto (si aplica)</li>
              </ul>
            </li>
          </ol>

          <h5 className="fw-bold mt-4">
            4. Opciones de reembolso y cambios
          </h5>
          <ul>
            <li>
              Reembolso del dinero al mismo medio de pago utilizado en la
              compra.
            </li>
            <li>Saldo a favor o nota de crédito, según el vendedor.</li>
            <li>
              Cambio por el mismo producto u otro de igual valor.
            </li>
            <li>Reembolso parcial, cuando corresponda.</li>
          </ul>
          <p>
            El tiempo estimado para procesar un reembolso es de
            <strong> 5 a 15 días hábiles</strong>, dependiendo de la entidad
            financiera y del método de pago.
          </p>

          <h5 className="fw-bold mt-4">
            5. Costos y responsabilidad del envío
          </h5>
          <ul>
            <li>
              Los costos de envío por cambios o devoluciones serán asumidos por
              el cliente.
            </li>
            <li>
              En caso de productos defectuosos o errores en el pedido, el
              envío será asumido por el vendedor, sin costo para el cliente.
            </li>
          </ul>

          <h5 className="fw-bold mt-4">6. Excepciones y garantías</h5>
          <p>
            En casos de productos dañados, defectuosos o errores en el pedido,
            se aplicará una política especial coordinada con el vendedor.
          </p>
          <p>
            Algunos productos pueden contar con garantía del fabricante, la
            cual deberá ser gestionada directamente con el proveedor.
          </p>

          <h5 className="fw-bold mt-4">
            7. Contacto y atención al cliente
          </h5>
          <p>
            Para consultas o reclamos relacionados con cambios y devoluciones,
            puedes contactarnos a través de:
          </p>
          <ul>
            <li>Correo: <strong>[admin@marketluz.com]</strong></li>
            <li>Teléfono / WhatsApp: <strong>[987157652]</strong></li>
            <li>Horario de atención: <strong>[Lunes a viernes de 8am a 5pm]</strong></li>
          </ul>

        </div>
      </div>
    </div>
  );
};

export default PoliticaDevoluciones;
